import { LitElement, html, css } from 'lit'
import { isTouchDevice } from '../../lib/utils'

export class MegaButton extends LitElement {
  static styles = css`
    :host {
      display: flex;
      color: #2f1f21;
    }

    a {
      color: inherit;
      text-decoration: unset;
    }

    button {
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      display: flex;
      font-family: inherit;
      align-items: center;
      justify-content: center;
      color: inherit;
      font-size: inherit;
      line-height: 1;
      font-weight: 700;
    }
  `

  static properties = {
    for: { type: String, reflect: true },
    link: { type: String },
    expanded: { type: Boolean },
  }

  constructor() {
    super()
    this.expanded = false
  }

  render() {
    return html`
      <button
        @click=${this._onClick}
        aria-expanded="${this.expanded}"
        aria-haspopup="true"
        aria-controls="${this.for}"
      >
        <slot></slot>
      </button>
    `
  }

  _onClick(e) {
    window.MicroBus.emit(`${this.for}:toggle`)
  }
}

customElements.define('mega-button', MegaButton)
